import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {SizeType} from './types';

type Props = {
  activeSizeIds: Array<string>;
  label?: string;
  onSizeClick: (sizeId: string) => void;
  sizes: Array<SizeType>;
  className?: string;
  enableFilterFlyout?: boolean;
};

export const SizeRun: FC<Props> = ({
  activeSizeIds,
  label,
  onSizeClick,
  sizes,
  className,
  enableFilterFlyout,
}) => {
  return (
    <>
      {label && <Title>{label}</Title>}
      <Sizes
        hasLabel={Boolean(label && label.length > 0)}
        className={className}
      >
        {sizes.map(size => (
          <Size
            active={activeSizeIds.includes(size.id)}
            data-testid={`filterSize_${size.id}`}
            key={`filter-size-${label}-${size.id}`}
            onClick={() => onSizeClick(size.id)}
            $withoutPadding={enableFilterFlyout}
          >
            {size.label}
          </Size>
        ))}
      </Sizes>
    </>
  );
};

const Title = styled.h5`
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px14};
  color: ${COLORS.Grey1};
  margin: 1.375rem 0 1.25rem 0;
`;

const Sizes = styled.div<{hasLabel: boolean}>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({hasLabel}) => (hasLabel ? '0' : '1.25rem')};
`;

const Size = styled.button<{active?: boolean; $withoutPadding?: boolean}>`
  box-sizing: border-box;
  height: 38px;
  ${props =>
    props.$withoutPadding
      ? css`
          min-width: 48px;
        `
      : css`
          padding: 0 0.875rem;
        `}
  border: ${({active}) =>
    active ? `2px solid ${COLORS.Black}` : `2px solid ${COLORS.Grey4}`};
  border-radius: 2px;
  margin: 0 0.5rem 0.625rem 0;
  background-color: ${({active}) => (active ? COLORS.White : COLORS.Grey4)};
  color: ${({active}) => (active ? COLORS.Black : COLORS.Grey1)};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${({active}) => (active ? COLORS.White : COLORS.Grey3)};
    border-color: ${({active}) => (active ? COLORS.Black : COLORS.Grey3)};
  }
`;
